<div>

  <label class=" col" [ngClass]="control.hasError('required') || control.hasError('minlength')  ? 'text-danger' : 'text-success'">
    <i [ngClass]="control.hasError('required') || control.hasError('minlength') ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
    {{'8-char'| translate}}
  </label>
  <label class="col" [ngClass]="control.hasError('required') || control.hasError('hasNumber')  ? 'text-danger' : 'text-success'">
    <i [ngClass]="control.hasError('required') || control.hasError('hasNumber') ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
    {{'1-number'| translate}}
  </label>
  <label class="col" [ngClass]="control.hasError('required') || control.hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
    <i [ngClass]="control.hasError('required') || control.hasError('hasCapitalCase') ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
    {{'1-char-capital'| translate}}
  </label>
  <label class="col" [ngClass]="control.hasError('required') || control.hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
    <i [ngClass]="control.hasError('required') || control.hasError('hasSmallCase') ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
    {{'1-char-small'| translate}}
  </label>
  <label class="col" [ngClass]="control.hasError('required') || control.hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
    <i [ngClass]="control.hasError('required') || control.hasError('hasSpecialCharacters') ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
    {{'1-char-special'| translate}}
  </label>

</div>
